module.exports = __webpack_public_path__ + "static/media/perche-6.1c73b990.svg";